import type { CSSProperties, SelectStylesNames } from '@mantine/core'
import { colors } from 'settings/colors'
import { SharedSettings } from 'settings/SharedSettings'

type TSelectStyles = Partial<Record<SelectStylesNames, CSSProperties>>

export const getStyles = (clearable: boolean, disabled: boolean): TSelectStyles => {
  return clearable ? getClearableStyles() : getNonClearableStyles(disabled)
}

const getClearableStyles = (): TSelectStyles => {
  return {
    dropdown: { marginTop: -6, fontWeight: 'normal' },
    input: { cursor: 'pointer' },
    option: { minHeight: 30 },
  }
}

const getNonClearableStyles = (disabled: boolean): TSelectStyles => {
  // TODO: Should customize a mantine <Select /> in our components folder that we then use through the app that deals with all these style tweaks.
  return {
    input: SharedSettings.MANTINE_SELECT_RIGHT_ICON_CHANGER.input,
    section: {
      ...SharedSettings.MANTINE_SELECT_RIGHT_ICON_CHANGER.section,
      '--select-chevron-color': disabled ? 'rgb(238,238,238)' : colors.midnight,
    },
  }
}
